/**
 * 初始化开发环境的用户信息
 * 注意，因为不是在爱病理app中，所以，移动端还是会走web端的鉴权。
 */
export function initDevUserInfo() {
    console.log('process.env: ', process.env)
    Reflect.set(window, 'userId', process.env.REACT_APP_DevUserId)
    Reflect.set(window, 'token', process.env.REACT_APP_DevToken)
    Reflect.set(window, 'deviceId', 'web_case_add')
}
